module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.extrasToEdit && _vm.extrasToEdit.length > 0) ? [_c('table', {
    staticClass: "w-100 dark mb-4"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.extrasToEdit), function(extra) {
    return _c('tr', {
      staticClass: "border-bottom-light border-top-light"
    }, [_c('td', {
      staticClass: "darker"
    }, [_vm._v(_vm._s(extra.component.name) + " - " + _vm._s(extra.componentPrice.name)), (!_vm.showEditControls(extra)) ? _c('span', {
      staticClass: "color-6"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "fs-small"
    }, [_vm._v(_vm._s(_vm.showSeller(extra)))]), _vm._v(" "), _c('td', {
      staticClass: "fs-small text-center"
    }, [_vm._v(_vm._s(_vm.showCommission(extra)))]), _vm._v(" "), _c('td', {
      staticClass: "fs-small text-center"
    }, [_vm._v(_vm._s(_vm.showAvailability(extra)))]), _vm._v(" "), _c('td', {
      staticClass: "fs-small text-center"
    }, [_vm._v(_vm._s(_vm.formatPrice(extra.componentPrice.grossprice)) + " €")]), _vm._v(" "), (!_vm.showEditControls(extra)) ? _c('td', {
      staticClass: "fs-small text-center"
    }, [_vm._v(_vm._s(extra.quantity))]) : _c('td', {
      staticClass: "d-flex flex-row justify-content-center py-1"
    }, [_c('span', {
      staticClass: "border-light py-1 px-2 radius-normal mx-1 text-center pointer",
      on: {
        "click": function($event) {
          return _vm.changeExtraQtd2('remove', extra, 'extra')
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-minus dark fs-smaller m-0"
    })]), _vm._v(" "), _c('input', {
      staticClass: "text-center fs-larger px-1 py-0 bg-lighter darker",
      staticStyle: {
        "width": "2.2rem"
      },
      attrs: {
        "type": "number",
        "placeholder": "0",
        "min": "0"
      },
      domProps: {
        "value": extra.quantity
      },
      on: {
        "input": function($event) {
          return _vm.debouncedQuantityChanged(extra, $event.target.value)
        },
        "focus": function($event) {
          return _vm.extraFocused(extra)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "border-light py-1 px-2 radius-normal mx-1 text-center pointer",
      on: {
        "click": function($event) {
          return _vm.changeExtraQtd2('add', extra, 'extra')
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-add dark fs-smaller m-0"
    })])])])
  }), _vm._v(" "), (!_vm.extrasTransportToEdit.length) ? _c('tr', {
    staticClass: "fs-large"
  }, [_c('th', {
    staticClass: "pt-2 extraNameWidth"
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticClass: "pt-2 pb-2"
  }), _vm._v(" "), _c('th', {
    staticClass: "pt-2 pb-2"
  }), _vm._v(" "), _c('th', {
    staticClass: "pt-2 pb-2"
  }), _vm._v(" "), _c('th', {
    staticClass: "pt-2 pb-2 text-center"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.calculatedExtrasTotal)) + " €")]), _vm._v(" "), _c('th', {
    staticClass: "pt-2 addRemoveWidth text-center"
  }, [_vm._v(_vm._s(_vm.totalExtras))])]) : _vm._e()], 2)] : _vm._e(), _vm._v(" "), (_vm.extrasTransportToEdit && _vm.extrasTransportToEdit.length > 0) ? [_c('table', {
    staticClass: "w-100 dark mb-4"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.extrasTransportToEdit), function(extra) {
    return _c('tr', {
      staticClass: "border-bottom-light border-top-light"
    }, [_c('td', {
      staticClass: "darker"
    }, [_vm._v(_vm._s(extra.component.name) + " - " + _vm._s(extra.componentPrice.name)), (!_vm.showEditControls(extra)) ? _c('span', {
      staticClass: "color-6"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "fs-small"
    }, [_vm._v(_vm._s(_vm.showSeller(extra)))]), _vm._v(" "), _c('td', {
      staticClass: "fs-small text-center"
    }, [_vm._v(_vm._s(_vm.showCommission(extra)))]), _vm._v(" "), _c('td', {
      staticClass: "fs-small text-center"
    }, [_vm._v(_vm._s(_vm.showAvailability(extra)))]), _vm._v(" "), _c('td', {
      staticClass: "fs-small text-center"
    }, [_vm._v(_vm._s(_vm.formatPrice(extra.componentPrice.grossprice)) + " €")]), _vm._v(" "), (!_vm.showEditControls(extra)) ? _c('td', {
      staticClass: "fs-small text-center"
    }, [_vm._v(_vm._s(extra.quantity))]) : _c('td', {
      staticClass: "d-flex flex-row justify-content-center py-1"
    }, [_c('span', {
      staticClass: "border-light py-1 px-2 radius-normal mx-1 text-center pointer",
      on: {
        "click": function($event) {
          return _vm.changeExtraQtd2('remove', extra, 'transport')
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-minus dark fs-smaller m-0"
    })]), _vm._v(" "), _c('input', {
      staticClass: "text-center fs-larger px-1 py-0 bg-lighter darker",
      staticStyle: {
        "width": "2.2rem"
      },
      attrs: {
        "type": "number",
        "placeholder": "0",
        "min": "0"
      },
      domProps: {
        "value": extra.quantity
      },
      on: {
        "input": function($event) {
          return _vm.debouncedQuantityChanged(extra, $event.target.value)
        },
        "focus": function($event) {
          return _vm.extraFocused(extra)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "border-light py-1 px-2 radius-normal mx-1 text-center pointer",
      on: {
        "click": function($event) {
          return _vm.changeExtraQtd2('add', extra, 'transport')
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-add dark fs-smaller m-0"
    })])])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "fs-large"
  }, [_c('th', {
    staticClass: "pt-2 extraNameWidth"
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticClass: "pt-2 pb-2"
  }), _vm._v(" "), _c('th', {
    staticClass: "pt-2 pb-2"
  }), _vm._v(" "), _c('th', {
    staticClass: "pt-2 pb-2"
  }), _vm._v(" "), _c('th', {
    staticClass: "pt-2 pb-2 text-center"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.calculatedExtrasTotal)) + " €")]), _vm._v(" "), _c('th', {
    staticClass: "pt-2 addRemoveWidth text-center"
  }, [_vm._v(_vm._s(_vm.totalExtras))])])], 2)] : (!_vm.extrasTransportToEdit.length && !_vm.extrasToEdit.length) ? _c('div', {
    staticClass: "fs-large dark text-center p-2"
  }, [_vm._v("\n        There are no extras to show\n    ")]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "fs-small"
  }, [_c('th', {
    staticClass: "extraNameWidth"
  }, [_vm._v("Extra")]), _vm._v(" "), _c('th', {
    staticClass: "pb-2"
  }, [_vm._v("Seller")]), _vm._v(" "), _c('th', {
    staticClass: "pb-2 text-center"
  }, [_vm._v("Commission")]), _vm._v(" "), _c('th', {
    staticClass: "pb-2 text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Availability")]), _vm._v(" "), _c('th', {
    staticClass: "pb-2 text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("Price/unit")]), _vm._v(" "), _c('th', {
    staticClass: "pb-2 text-center",
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("Quantity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "fs-small"
  }, [_c('th', {
    staticClass: "extraNameWidth"
  }, [_vm._v("Transport")]), _vm._v(" "), _c('th', {
    staticClass: "pb-2"
  }, [_vm._v("Seller")]), _vm._v(" "), _c('th', {
    staticClass: "pb-2 text-center"
  }, [_vm._v("Commission")]), _vm._v(" "), _c('th', {
    staticClass: "pb-2 text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Availability")]), _vm._v(" "), _c('th', {
    staticClass: "pb-2 text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("Price/unit")]), _vm._v(" "), _c('th', {
    staticClass: "pb-2 text-center",
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("Quantity")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6b7f4b4b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b7f4b4b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/AddExtra/ExtrasManager.vue
// module id = 1685
// module chunks = 0